import PropTypes from 'prop-types';
import { styled, useTheme } from '@mui/material/styles';
import { Box, Card, Typography, Chip, Stack } from '@mui/material';
import {
    IconVideo,
    IconFileText,
    IconFileTypePdf,
    IconExternalLink,
    IconQuestionMark
} from '@tabler/icons-react';
import MainCard from '../../../component/cards/MainCard';

const CardWrapper = styled(MainCard)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    color: '#fff',
    position: 'relative',
    cursor: 'pointer',
    overflow: 'hidden'
}));

const ICONS = {
    video: <IconVideo size={80} color={'#ffffff'} />,
    text: <IconFileText size={80} color={'#ffffff'} />,
    pdf: <IconFileTypePdf size={80} color={'#ffffff'} />,
    link: <IconExternalLink size={80} color={'#ffffff'} />,
    quiz: <IconQuestionMark size={80} color={'#ffffff'} />,
    html: <IconFileText size={80} color={'#ffffff'} />
};

function LearningCard({ content, onClick }) {
    const theme = useTheme();

    const hasFeatured = Boolean(content.featured_media?.url);

    return (
        <CardWrapper
            content={false}
            onClick={onClick}
            sx={{
                '&:hover': {
                    boxShadow: 6,
                    transform: 'scale(1.02)',
                    transition: '0.2s ease-in-out'
                },
                borderRadius: 3
            }}
        >
            <Card
                elevation={0}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                    height: '100%'
                }}
            >
                {/* Feature Image */}
                <Box
                    sx={{
                        width: '100%',
                        height: 180,
                        position: 'relative',
                        backgroundColor: hasFeatured
                            ? 'transparent'
                            : 'rgba(255,255,255,0.05)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        overflow: 'hidden'
                    }}
                >
                    {hasFeatured ? (
                        <img
                            src={content.featured_media.url}
                            alt={content.title}
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'cover',
                                borderTopLeftRadius: 12,
                                borderTopRightRadius: 12
                            }}
                        />
                    ) : (
                        ICONS[content.type] || (
                            <IconFileText size={80} color={'#ffffff'} />
                        )
                    )}
                </Box>

                {/* Titulo e desc */}
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        p: 2
                    }}
                >
                    <Box>
                        <Typography variant="h5" color="#fff" fontWeight="bold" noWrap>
                            {content.title}
                        </Typography>

                        <Typography
                            variant="body2"
                            color="#d6d5d5"
                            sx={{
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                mt: 0.5
                            }}
                        >
                            {content.description}
                        </Typography>

                        {content.tags?.length > 0 && (
                            <Stack direction="row" spacing={1} mt={1} flexWrap="wrap">
                                {content.tags.map((t) => (
                                    <Chip
                                        key={t.uuid}
                                        label={t.tag}
                                        size="small"
                                        sx={{
                                            color: '#fff',
                                            borderColor: theme.palette.primary.light
                                        }}
                                        variant="outlined"
                                    />
                                ))}
                            </Stack>
                        )}
                    </Box>
                </Box>
            </Card>
        </CardWrapper>
    );
}

LearningCard.propTypes = {
    content: PropTypes.object.isRequired,
    onClick: PropTypes.func
};

export default LearningCard;
